import styled from 'styled-components';

export const Header = styled.header`
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
`;
